export default __webpack_public_path__ + "static/media/BombDisposal.4855a815.svg";